import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

const useContactSubscribes = (reactQueryOptions?: UseQueryOptions<any, Error>) => {
    const path = CuredApiPaths.REPORT_CONTACTS_SUBSCRIBES;

    return useQuery('contacts-subscribes', path, reactQueryOptions);
};

export default useContactSubscribes;
